
import { ref, useContext } from '@nuxtjs/composition-api';
import useTlmCart from '@/composable/useTlmCart';
import useUtilities from '~/composable/useUtilities';
import useCategories from '@/composable/useCategories';
import useCartQueries from '~/composable/useCartQueries';

export default {
  name: 'TlmCheckoutAccessoriesOverview',
  setup () {
    const { formatPrice } = useUtilities()

    const showOrder = ref(false)
    const { app } = useContext()
    const { cart, isAnyItemInPreOrderOrBackOrder } = useTlmCart(app);
    const { cartOnlyContainsSubscription } = useCartQueries(app, cart)
    const { hasSpecialPrices } = useCategories(app.$hubble)

    return {
      isSubscriptionOnly: cartOnlyContainsSubscription,
      hasSpecialPrices,
      isAnyItemInPreOrderOrBackOrder,
      formatPrice,
      showOrder,
      cart
    }
  }
}
